<template>
    <div
        id="bike-theft-claim-flow-equipment"
        class="container"
        data-test-bike-theft-claim-flow-equipment
    >
        <div class="row">
            <div class="large-10 large-offset-2 columns callout">
                <h2 class="heading1">
                    Du har tilføjet
                </h2>

                <ul>
                    <div
                        v-for="(item, index) in equipment"
                        :key="'bike-theft-claim-flow-equipment-item-' + index"
                        class="row"
                        :data-test="'bike-theft-claim-flow-equipment-item-' + index"
                    >
                        <div class="medium-8 small-8 columns">
                            <li>
                                {{ item.name }}, {{ item.age }} gammel
                            </li>
                        </div>
                        <div class="medium-3 small-3 columns">
                            {{ item.price }},00 kr
                        </div>
                        <div class="medium-1 small-1 columns">
                            <a
                                data-test="proposal-basket-button-remove"
                                class="link-icon"
                                @click="$store.dispatch('bikeTheftClaimFlow/removeEquipmentItem', index)"
                            ><i
                                title="Slet"
                                class="icon-trash"
                            /></a>
                        </div>
                    </div>
                </ul>

                <hr>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Equipment',
    computed: {
        ...mapState({
            equipment: (state) => state.bikeTheftClaimFlow.data.submitData.bicycleClaimQuestionsTemplateModel.equipment
        })
    }
};
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.callout  {
    margin-top: rem-calc(230);
}

a {
    text-decoration: none;
}

.callout {
    > :last-child {
        margin-bottom: rem-calc(150);
    }
}

</style>